/**
 * @author MadhuSudhan
 * @Date: 2023-09-13 13:13:07
 * @Last Modified by: madhusudhan
 * @Last Modified time: 2023-09-15 15:44:52
 */

import { fromJS } from 'immutable';
import { BLOCK_CARD_OTP_SUCCESS, BLOCK_CARD_SUCCESS } from './constants';
import { DEFAULT_ACTION } from '../NetworkCards/constants';

const initialState = fromJS({
  isLoading: false,
  blockCardSuccess: {},
  blockCardOtpSuccess: {},
});

function yscCardActionsReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case DEFAULT_ACTION:
      return state
        .set('isLoading', payload);
    case BLOCK_CARD_OTP_SUCCESS:
      return state
        .set('blockCardOtpSuccess', fromJS(payload))
        .set('isLoading', false);
    case BLOCK_CARD_SUCCESS:
      return state
        .set('blockCardSuccess', fromJS(payload))
        .set('isLoading', false);
    default:
      return state;
  }
}

export default yscCardActionsReducer;



// WEBPACK FOOTER //
// client/containers/YscCardActions/reducer.js